import { render } from "./DownloadRequests.vue?vue&type=template&id=3b264ce2"
import script from "./DownloadRequests.vue?vue&type=script&lang=js"
export * from "./DownloadRequests.vue?vue&type=script&lang=js"

import "./DownloadRequests.vue?vue&type=style&index=0&id=3b264ce2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__